import styled from 'styled-components6';
import { Diamond } from './Diamond';

const Chip = styled.div`
    background: linear-gradient(139deg, #aa68ff -2.88%, #51a4ff 76.92%);
    border-radius: 24px;
    display: inline-flex;
    position: absolute;
    z-index: 1;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    margin: 8px;
`;

const Text = styled.span`
    color: white;
    font-size: 10px;
    font-weight: 700;
`;

export const ShowcaseChip = (): JSX.Element => {
    return (
        <Chip className="rwlShowCaseChip">
            <Diamond />
            <Text>SHOWCASE</Text>
        </Chip>
    );
};
